import AppConfig from '@/AppConfig';
// Classes
import Race from '@/classes/race';
import Driver from '@/classes/driver';
import Team from '@/classes/team';
import dayjs from 'dayjs';

// Modules

import User from '@/classes/user';
import ImsError from '@/modules/errors/errors';

let $User: User;

export default {
  state: {
    race: null, // when read will have full race class
    races: [],
    drivers: []
  },
  mutations: {
    race(state: any, race: Race) {
      state.race = race;
    },
    'races/set'(state: any, races: Array<Race>) {
      state.races = races;
    }
  },
  getters: {
    'race/byId'(state: any) {
      return (id: number) => {
        return state.races.find((race: Race) => race.id == id);
      };
    },
    'races/available'(state: any) {
      const today = dayjs();
      const allowed = [
        AppConfig.status.IN_PROGRESS,
        AppConfig.status.COMPLETE,
        AppConfig.status.PRE_RACE
      ];
      return (state.races || []).filter((race: Race) => {
        if (race) {
          if (allowed.indexOf(race.status) > -1) {
            // Filter out Older Races by Number of Months back
            let age = today.diff(dayjs(race.greenFlagDateTime), 'month');
            // Is it too old or not?
            return age < AppConfig.maxRaceAgeToShow ? true : false;
            // return false;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    }
  },
  actions: {
    'race/byId'(context: any, id: Number) {
      return context.state.races.find((race: Race) => {
        race.id == id;
      });
    },
    /**
     * Select a Race
     */
    async 'race/fullById'(context: any, id: number) {
      let closeLoader = await context.dispatch(
        'loader/start',
        'Getting Race Details...'
      );

      let race = await $User.service.getRace(id);

      // Get Drivers & Team for this Race
      let drivers = await $User.service.getDrivers(race.id);
      race.drivers = drivers;

      // Get the Team for this user and this race
      let team: Team = await $User.service.getTeam(race.id);
      race.team = team;

      // Commit Race Data
      context.commit('race', race);
    },
    'races/init'(context: any, user: User) {
      $User = user;
    },
    async 'races/load'(context: any, from: any = 'unknown') {
      // Show Loading
      let closeLoader = await context.dispatch(
        'loader/start',
        'Finding Races...'
      );

      // Get the Races ALL

      let racesRaw: Array<any> = [];
      try {
        racesRaw = await $User.service.getRaces();
      } catch (e) {
        let raceError = new ImsError(e);
        context.dispatch(
          'interact/error',
          `Problem Loading Race: ${raceError.getDescription()}`
        );
      }
      // Get last Race ID.
      let storage = context.getters['storage'];
      let lastRaceId: any = storage.get('last-race-id');

      let races: Array<Race | null> = racesRaw.sort((a: any, b: any) => {
        return a.greenFlagDateTime > b.greenFlagDateTime ? 1 : -1;
      });

      // Commit the Races
      context.commit('races/set', races);
      closeLoader();

      // Get the last Race ID, or use races first item
      // Some Typescript hackery here! Gracious
      if (lastRaceId === null && races.length) {
        // Is there a race in 0, and does it have an ID
        const firstRaceId = (races[races.length - 1] || { id: null }).id;
        if (firstRaceId) {
          lastRaceId = firstRaceId;
        }
      }
      // No if we have a race - load it.
      // Otherwise don't
      if (lastRaceId !== null) {
        let race = context.getters['races/available'].find(
          (r: any) => r.id == lastRaceId
        );
        if (race) {
          context.dispatch('race/select', race);
        }
      }
      return races;
    },
    /**
     * Select a Race
     */
    async 'race/select'(context: any, race: Race) {
      let closeLoader = await context.dispatch(
        'loader/start',
        'Getting Race Details...'
      );

      // Get Drivers & Team for this Race
      let drivers = await $User.service.getDrivers(race.id);
      race.drivers = drivers;

      // Get the Team for this user and this race
      let team: Team = await $User.service.getTeam(race.id);
      race.team = team;

      // Commit Race Data
      context.commit('race', race);

      // Update Last Race Id and store it
      let storage = context.getters['storage'];
      storage.set('last-race-id', race.id);

      // Hide Loading
      closeLoader();
    }
  }
};
